const numberFormatter = new Intl.NumberFormat('vi-VN', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const formatMoney = {
  format(value) {
    const num = Number(value);
    if (!Number.isFinite(num)) return '0 VND';
    return `${numberFormatter.format(num)} VND`;
  },
};

export default formatMoney;
